export default "__VITE_ASSET__B2tZtvN2__"